<template>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="name">Phones: </label>
        <div>
          <draggable v-model="nav_menus" class="list-group">
            <div class="list-group-item" v-for="(n, index) in nav_menus" :key="index">
              
              <div class="d-flex justify-content-between align-items-center" v-if="!edited_item[index]">
                <span>{{n.name}} <small class="text-grey nav-link-text" v-if="n.phone">{{n.phone}}</small></span>
                <span>
                  <span @click="setEditDisplay(index)"><i class="fa fa-edit text-info"></i></span>
                  <span @click="removeNav(nav_menus, index)"><i class="far fa-trash-alt text-danger" style="margin-left: 10px;"></i></span>
                </span>
              </div>
              <div class="row" v-if="edited_item[index]" v-on-clickaway="outside">
                <div class="col-sm-6">
                  <input class="form-control" v-model="n.name" type="text" placeholder="Name">
                </div>
                <div class="col-sm-6">
                  <input class="form-control" v-model="n.phone" type="text" placeholder="Phone">
                </div>
              </div>

            </div>
            <div class="list-group-item text-success" @click="addNewNav"><strong><i class="fa fa-plus"></i> เพิ่ม</strong></div>
          </draggable>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'navOption',
  props: ['value'],
  components: { draggable },
  directives: { onClickaway: onClickaway },
  data() {
    return {
      nav_menus: this.value ? this.value : [],
      edited_item: {},
      sub_edited_item: {},
    }
  },
  watch: {
    nav_menus(newValue) {
      this.$emit('input', newValue)
    }
  },
  methods: {
    outside() {
      Object.keys(this.edited_item).forEach((key) => {
        this.edited_item[key] = false
      })
      Object.keys(this.sub_edited_item).forEach((key) => {
        this.sub_edited_item[key] = false
      })
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    addNewNav() {
      this.nav_menus.push({
        name: "",
        phone: ""
      })
      this.setEditDisplay(this.nav_menus.length-1)
    },
    removeNav(list, index) {
      list.splice(index, 1)
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    setEditDisplay(index) {
      this.edited_item[index] = true
      this.nav_menus.push({})
      this.nav_menus.pop()
    },
    setSubEditDisplay(index) {
      this.sub_edited_item[index] = true
      this.nav_menus.push({})
      this.nav_menus.pop()
    }
  }
}
</script>

<style lang="scss">
.sub-nav {
  margin-top: 20px;
}
.nav-link-text {
  margin-left: 10px;
}
</style>
